import { TipoValidacaoEstoqueNegativoEnum } from '../../../../../shared/enums/vendas/tipo-validacao-estoque-negativo.enum';
import { UtilService } from '../../../../../shared/services/util.service';

/**
 * Saldo no LANÇAMENTO do item (§6.2.1, tabela "Permite estoque negativo"), a mesma regra para o
 * campo Item, a bipagem e o diálogo de múltiplo:
 *
 * - Sim (1): o aviso é informativo, a linha entra e o indicador da linha mostra a falta.
 * - Todos os depósitos (2): sem saldo na SOMA dos depósitos, a leitura é recusada.
 * - Depósito selecionado (3): olha só o depósito do ITEM; o saldo consultado já vem
 *   filtrado por `idLocalizacaoEstoque`; sem saldo ali, recusa mesmo que outro depósito tenha.
 *
 * O bloqueio ao SALVAR (`isBloquearEstoqueInsuficiente`, §15 #8) é do orquestrador; aqui é a
 * conferência de quem está lançando, para não montar o documento e descobrir no fim.
 */
export interface ResultadoDoSaldo {
    permitido: boolean;
    /** Texto do aviso (bloqueio ou informação), nulo quando o saldo cobre. */
    aviso: string | null;
}

export function validarSaldoNoLancamento(
    tipoValidacao: number | null | undefined,
    saldoDisponivel: number | null | undefined,
    quantidade: number,
    descricao: string,
    casasQuantidade: number,
): ResultadoDoSaldo {
    const saldo = Number(saldoDisponivel ?? 0);
    const qtd = Number(quantidade) || 0;

    if (saldo >= qtd) return { permitido: true, aviso: null };

    const numero = (v: number): string =>
        UtilService.arredondarAbnt(v, casasQuantidade).toLocaleString('pt-BR', { maximumFractionDigits: casasQuantidade });
    const situacao = `${descricao}: disponível ${numero(saldo)}, lançado ${numero(qtd)}.`;

    switch (tipoValidacao) {
        case TipoValidacaoEstoqueNegativoEnum.TodosDepositos:
            return { permitido: false, aviso: `Estoque insuficiente na soma das localizações de estoque. ${situacao}` };
        case TipoValidacaoEstoqueNegativoEnum.DepositoSelecionado:
            return { permitido: false, aviso: `Estoque insuficiente na localização de estoque do item. ${situacao}` };
        default:
            return { permitido: true, aviso: `Saldo insuficiente. ${situacao} A empresa permite estoque negativo.` };
    }
}

/** O depósito que a consulta de saldo deve filtrar: só quando a regra olha o depósito selecionado no item. */
export function localizacaoEstoqueParaConsultaDeSaldo(
    tipoValidacao: number | null | undefined,
    idLocalizacaoEstoque: number | null | undefined,
): number | null {
    return tipoValidacao === TipoValidacaoEstoqueNegativoEnum.DepositoSelecionado ? (idLocalizacaoEstoque ?? null) : null;
}
